import Icon from '../../components/Icon.vue'

Icon.register({"brands/facebook-square":{"width":448,"height":512,"paths":[{"d":"M448 80V432C448 458.5 426.5 480 400 480H314.7V302.8H375.3L384 235.2H314.7V192C314.7 172.4 320.1 159.1 348.2 159.1H384V98.7C377.8 97.9 356.6 96 331.8 96 280.2 96 244.8 127.5 244.8 185.4V235.3H184V302.9H244.9V480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/facebook-square.js
// module id = 3xD1
// module chunks = 0